import { render, staticRenderFns } from "./params-setting-legacy.vue?vue&type=template&id=1989e560&scoped=true&"
import script from "./params-setting-legacy.vue?vue&type=script&lang=js&"
export * from "./params-setting-legacy.vue?vue&type=script&lang=js&"
import style0 from "./params-setting-legacy.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./params-setting-legacy.vue?vue&type=style&index=1&id=1989e560&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1989e560",
  null
  
)

export default component.exports